import { Component, Prop } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { formatDateLocal } from '@/helpers/dates';
import { LocationDTO } from '../../../model/LocationDTO';
import { EnergyClassDTO } from '../../../model/EnergyClassDTO';
import { apartmentsOverviewInfoData } from './apartments-overview-info.data';

@Block(apartmentsOverviewInfoData)
@Component
export class ApartmentsOverviewInfoBlock extends BaseBlock {
	@Prop() location: LocationDTO;
	@Prop() energyClass: EnergyClassDTO;

	get currentDateFormated() {
		return formatDateLocal(this.getCurrentDate());
	}
}

export default ApartmentsOverviewInfoBlock;
